import { GWAcknowledgement } from './gw-acknowledgement.model';
import { GWCoverage } from './gw-coverage.model';
import { GWAttribute } from './gw-attribute.model';

export class GWBaseQuote {
    public id: number;
    public eventId: number;
    public ratingEngineId: string;
    public planId: string;
    public planName: string;
    public totalPremium: number;
    public basePremium: number;
    public totalFees: number;
    public coverages: GWCoverage[];
    public acknowledgements: GWAcknowledgement[];
    public attributes: GWAttribute[];
    public selected: boolean;
    public planPriority: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-base-quote.model.ts